import axios from "axios";
import Util from "../Util";

const $ = window.$;
const server = window.API_URL.url;


const actions = {
  Auth: {
    urlLogin: server + 'Account/Login',
    urlGetReport: server + 'LoginsRes/GetReport',
    SaveUser: server + 'AccountUsers/Save',
    ChangePwd: server + 'AccountUsers/ChangePwd'
  },
  Traffic: {
    GetStepsCongestion: server + 'congestion/GetStepsCongestion',
    GetStepsDetails: server + 'congestion/GetStepsDetails',
  },
  Trips: {
    GetTrips: server + 'Trips/GetTrips',
  },
  Users: {
    GetUsers: server + 'AccountUsers/GetUsers'
  },
  Careers: {
    Save: server + 'Careers/Save'
  },
  ContactUs: {
    Save: server + 'ContactUs/Save'
  }
};

function getHeaders(isMultipart = false) {
  const user = JSON.parse(localStorage.getItem("traffic_user"));
  const userId = user?.ID; // or whatever the property name is
  const token = user?.Token;

  return {
    headers: {
      "Content-Type": isMultipart ? "multipart/form-data" : "application/json",
      token: token,
      lang_id: localStorage.getItem("traffic_lang") || 'ar',
      user_id: userId || 1,
    },
  };
}

async function handleError(err, t) {
  if (err.response && err.response.status === 401) {

    Util.logout();
  }
  return {
    status: err.response ? err.response.status : 500,
    message: err.response ? err.response.data : err.message,
    data: []
  };
}

const http = {
  actions,

  postJsonAxios: async function (url, data, t) {
    try {
      const resp = await axios.post(url, JSON.stringify(data), getHeaders());
      return { status: resp.status, message: '', data: resp.data };
    } catch (err) {
      return handleError(err, t);
    }
  },

  postMultipartAxios: async function (url, data, file, files, t) {
    try {
      let form = new FormData();
      form.append('json', JSON.stringify(data));
      if (file) form.append('file', file, file.name);
      if (files) files.forEach(f => form.append('files', f, f.name));
      const resp = await axios.post(url, form, getHeaders(true));
      return { status: resp.status, message: '', data: resp.data };
    } catch (err) {
      return handleError(err, t);
    }
  },

  postMultipartObjAxios: async function (url, data, file, files, fileIds, t) {
    try {
      let form = new FormData();
      form.append('json', JSON.stringify(data));
      if (file) form.append('file', file, file.name);
      if (files && fileIds && files.length === fileIds.length) {
        for (let i = 0; i < files.length; i++) {
          form.append('files', files[i], fileIds[i]);
        }
      }
      const resp = await axios.post(url, form, getHeaders(true));
      return { status: resp.status, message: '', data: resp.data };
    } catch (err) {
      return handleError(err, t);
    }
  },

  getJsonAxios: async function (url, params, t) {
    try {
      const options = getHeaders();
      if (params) options.params = params;
      const resp = await axios.get(url, options);
      return { status: resp.status, message: '', data: resp.data };
    } catch (err) {
      return handleError(err, t);
    }
  }

};

export default http;
